(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingFuiteEau', ReportingFuiteEau);

    ReportingFuiteEau.$inject = ['$resource'];

    function ReportingFuiteEau ($resource) {
        var resourceUrl =  'api/reporting-fuite-eau/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'}
        });
        
    }
})();
